import { Pipe, PipeTransform } from '@angular/core';
import { BASE_URI } from '@config/global-constants';
@Pipe({
  name: 'xviSourcePath',
})
export class SourcePathPipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public transform(value: string, args: string[]): string {
    return value ? BASE_URI.concat(value) : value;
  }
}
